// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"40f2cd51","431":"1e64c28d","787":"0d5bf7ca","832":"73227817","890":"8aee7d5c","986":"6f546889"}[chunkId] + ".chunk.js";
};